import { render, staticRenderFns } from "./RequestListDetail.vue?vue&type=template&id=62e38b0d&scoped=true&"
import script from "./RequestListDetail.vue?vue&type=script&lang=js&"
export * from "./RequestListDetail.vue?vue&type=script&lang=js&"
import style0 from "./RequestListDetail.vue?vue&type=style&index=0&id=62e38b0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e38b0d",
  null
  
)

export default component.exports